import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=bee41ee4&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"
import style0 from "./Workflow.vue?vue&type=style&index=0&id=bee41ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee41ee4",
  null
  
)

export default component.exports